import Box from "@mui/material/Box";
import {CheckBoxWithLabel} from "../../../domains/common/components/FormInput";
import React from "react";

export function DealParamsMortgageAndExpress({dealData, onChange}) {
  return (
    <Box sx={{display:'flex',flexDirection:'row',gap:2,alignItems:'flex-start'}}>
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      width: 'fit-content',
      height: '100px',
      overflow: 'auto'
    }}>
      <CheckBoxWithLabel
        inputProps={{className: `dealForm`}}
        label="Наличие ипотеки"
        name="dealWithMortgage"
        sx={{height: 30}}
        checked={!!dealData?.deal?.dealWithMortgage}
        onChange={(e) => onChange ? onChange({dealWithMortgage: e.target.checked}) : void 0}/>
      <DealExpressParam dealData={dealData} onChange={onChange} />
      <DealMilitaryParam dealData={dealData} onChange={onChange} />
    </Box>
    </Box>
  )
}

export function DealExpressParam({dealData, onChange}) {
  return (
    <CheckBoxWithLabel
      inputProps={{className: `dealForm`}}
      sx={{height: 30}}
      label="Экспресс-сделка"
      name="express"
      checked={!!dealData?.deal?.express}
      onChange={(e) => onChange ? onChange({express: e.target.checked}) : void 0}/>)
}

export function DealMilitaryParam({dealData, onChange}) {
  return (
    <CheckBoxWithLabel
      inputProps={{className: `dealForm`}}
      sx={{height: 30}}
      label="Военная ипотека"
      name="military"
      checked={!!dealData?.deal?.military}
      onChange={(e) => onChange ? onChange({military: e.target.checked}) : void 0}/>)
}